import Axios from "axios";
import store from '@sl/base/store';
import lang from "@sl/base/filters/lang";

export class Request {
    constructor(scene) {
        this.scene = scene;
        this.scenario = undefined;
        this.previousScenario = undefined;
        this.stepScenario = undefined;
        this.stepType = 'next';
        this.ticketId = undefined;
        this.demoId = undefined;
        this.amountWon = undefined;
        this.totalAmountWon = undefined;
        this.amount = undefined;
        this.ticketInProgress = false;
        this.bonusAmountWon = undefined;
        this.explanationStatus = false;
        this.lastActionTime = new Date();
    }
    
    async purchase(mechanicalClick) {
        if(typeof this.scene.spinClickSound === 'function') {
            this.scene.spinClickSound();
        }

        if(this.scene.bonusStageRunning) {
            return;
        }

        //if slot animation spinning
        if(this.scene.slots.spinStarted) {
            if(mechanicalClick) {
                this.scene.slots.speedUpSpin();
            }
            
            return;
        }
        
        //quick sping if clicked by user and there is some playable scenario
        if(mechanicalClick && (this.scenario || this.stepScenario)) {
            this.scene.winning.skip();
        }

        if(this.scene.freeSpinsAnimationRunning) {
            return;
        }

        if(mechanicalClick && (this.scenario || this.stepScenario)) {
            this.scene.bonus.reset();
        }

        if(this.ticketInProgress) {
            return;
        }

        if(Config.settings.min_delay_ms) {
            var startTime = new Date().getTime();
        }

        this.setTicketStatus(true);

        this.scene.beforePurchase();
        
        this.scenario = {};

        if(store.getters.autoSpins) {
            store.commit('setAutoSpin', store.getters.autoSpins-1);
        }

        store.commit('setAmountWon', 0);
        store.commit('setTotalAmountWon', 0);
        this.totalAmountWon = undefined;

        try {
            this.scene.afterPurchase();
            this.lastActionTime = new Date();

            const { data: retrieved } = await Axios.post(Config.route.purchase, {
                mode: Config.mode,
                game_id: Config.game_id,
                shop_id: Config.shop_id,
                amount_id: Config.current_amount.id,
                lines_count: store.getters.currentPayline,
                replay_id: Config.replay_id,
            });

            const res = this.parseResponse(retrieved);

            this.markPlayerText(res, () => {
                if (res.success) {
                    let timeout = 0;

                    if(Config.settings.min_delay_ms) {
                        const requestTime = Config.settings.min_delay_ms - (new Date().getTime() - startTime);
                        if(requestTime > 0) {
                            timeout = requestTime;
                        }
                    }

                    setTimeout(() => {
                        this.scene.slots.gotScenario(res.scenario);
                        this.previousScenario = this.scenario;
                        this.scenario = res.scenario;
                        this.ticketId = res.ticket_id;
                        this.demoId = res.demo_id;
                        store.commit('setBalance', res.balance);
                    }, timeout);

                    store.commit('reelSpinStatus', true);
                } else {
                    this.setTicketStatus(false);

                    if (res.info != 'player_text') {
                        this.markError(res.text || lang('general_error'));

                        if(res.code == 'wrong_balance') {
                            this.wrongBalance();

                            if (Config.wallet_page) {
                                store.commit('setMessageAdditional', {
                                    title: 'add_funds',
                                    type: 'add_funds',
                                    callback: () => window.top.location.href = Config.wallet_page,
                                });
                            }
                        }
                    }
                }
            });
        } catch (err) {
            console.error(err);
            this.setTicketStatus(false);
            this.markError(lang('general_error'));
        }
    }
    
    async step(choice) {
        if (this.scene.slots.resetSlot) {
            this.scene.slots.resetSlot = false;
            return;
        }
        
        try {
            this.lastActionTime = new Date();
            
            const { data: retrieved } = await Axios.post(Config.route.step, {
                mode: Config.mode,
                game_id: Config.game_id,
                shop_id: Config.shop_id,
                ticket_id: this.ticketId,
                demo_id: this.demoId,
                choice: choice,
                type: this.stepType,
                replay_id: Config.replay_id,
            });

            const res = this.parseResponse(retrieved);

            this.markPlayerText(res, () => {
                if (res.success) {
                    this.stepScenario = res.scenario;
                    this.stepType = 'next';
                    this.amountWon = 0;
                    this.totalAmountWon = 0;

                    if(res.amount) {
                        this.amount = res.amount;
                    }
                    if (res.amount_won) {
                        this.amountWon = res.amount_won;
                    } else if (res.scenario && typeof res.scenario.amount_won !== 'undefined') {
                        this.amountWon = res.scenario.amount_won;
                    }

                    this.scene.winning.play(() => {
                        this.previousScenario = this.scenario;
                        this.scenario = res.scenario;

                        if(res.total_amount_won) {
                            this.totalAmountWon = res.total_amount_won;
                        }

                        if(res.scenario && res.bonus_stage && res.scenario.amount_won ) {
                            this.amountWon = res.scenario.amount_won;
                        }

                        this.setFreeSpins();

                        if(this.scenario) {
                            store.commit('setAmountWon', 0);
                            this.scene.slots.gotScenario(this.scenario);
                        } else {
                            this.setTicketStatus(false);
                            store.commit('setBalance', res.balance);
                            if (res.amount_won) {
                                this.amountWon = res.amount_won;

                                if(this.requestAfterBonuses()) {
                                    store.commit('setTotalAmountWon', this.amountWon);
                                }

                                if (store.state.autoSpinsSettings.stopOnWin) {
                                    store.commit('setAutoSpin', 0);
                                }
                            }

                            if (res.bonus_amount_won) {
                                this.bonusAmountWon = res.bonus_amount_won;
                            }
                        }

                        this.scene.afterStep();
                    });
                } else {
                    this.setTicketStatus(false);
                    if (res.info != 'player_text') {
                        this.markError(res.text || lang('general_error'));
                    }
                }
            });
        } catch (err) {
            console.error(err);
            this.setTicketStatus(false);
            this.markError(lang('general_error'));
            
        }
    }

    parseResponse(res) {
        if (!res.blob) {
            return res;
        }

        return JSON.parse(atob(res.blob));
    }

    requestAfterBonuses() {
        return this.previousScenario && (this.previousScenario.freespins || this.previousScenario.bonus_stage);
    }

    setTicketStatus(status) {
        this.ticketInProgress = status;
    }

    loadWaitingTicket(id, hasScenarios) {
        store.commit('reelSpinStatus', true);
        this.setTicketStatus(true);
        this.ticketId = id;
        this.stepType = 'repeat';

        store.commit('setMessage', hasScenarios ? lang('unfinished_game') : lang('unpayed_game'));

        if(hasScenarios.bonus_stage) {
            store.commit('setAfterMessage', () => this.scene.unfinishedBonusStage(hasScenarios));
        } else {
            store.commit('setAfterMessage', 
                () => {
                    if(typeof this.scene.unfinishedFreeSpins === 'function') {
                        this.scene.unfinishedFreeSpins(hasScenarios);
                    }

                    this.step();
                }
            );
        }
    }
    
    setAutoSpin() {
         //if all steps are finished
        if(store.getters.reelSpinning) {
            return;
        }

        if(store.getters.autoSpins) {
            this.purchase();
        }
    }

    spinStopped() {
        store.commit('reelSpinStatus', false);
    }

    showControls(show) {
        store.commit('showControls', show);
    }

    spinFinished() {
        if(!store.getters.ticketInProgress && store.getters.gracefulPause) {
            return;
        }

        if(store.getters.autoSpins) {
            this.purchase();
        }
    }

    markError(text) {
        store.commit('setAutoSpin', 0);
        this.spinFinished();

        store.commit('setMessage', text);
        store.commit('setAfterMessage', () => location.reload());
    }

    markPlayerText(res, after) {
        if (res.info == 'player_text') {
            store.commit('setMessage', res.text);
            store.commit('setAfterMessage', () => {
                after();

                if (res.action == 'reload') {
                    location.reload()
                } else if (res.action == 'close' && Config.home_url) {
                    window.location.replace(Config.home_url);
                } else {
                    this.scene.slots.resetSlotSpin();
                }
            });
        } else {
            after();
        }
    }

    setFreeSpins() {
        let scenario = undefined;

        if(this.scenario && this.scenario.freespins) {
            scenario = this.scenario.freespins;
        }

        store.commit('setFreeSpins', scenario);
    }

    setExplanationStatus(status) {
        this.explanationStatus = status;

        if(typeof this.scene.afterExplanationToggle === 'function') {
            this.scene.afterExplanationToggle();
        }
    }

    wrongBalance() {
        if(typeof this.scene.wrongBalance === 'function') {
            this.scene.wrongBalance();
        }
    }
}
